import {
  MaritalInformationFormT,
  MaritalInformationSpouseResponseT,
  MaritalInformationSpouseT,
  MartialInformationResponseT,
} from '../../types';
import { addressTransform } from '../address/address';

export const isMarriedStatus = {};

export const deserializeSpouse = (spouse: MaritalInformationSpouseResponseT): MaritalInformationSpouseT => {
  return {
    address: spouse.address && addressTransform.deserialize(spouse.address),
    firstName: spouse.first_name,
    lastName: spouse.last_name,
    sameAddress: spouse.same_address,
  };
};

export const deserializeMaritalInformation = (response: MartialInformationResponseT): MaritalInformationFormT => {
  return {
    maritalStatus: response.marital_status,
    spouse: response.spouse && deserializeSpouse(response.spouse),
  };
};
